import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { ALL_UPLOADED_SHEET } from "../../../api/allApi_List";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import UploadedSheetList from "../components/UploadedSheetList";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import MainPageLayout from "../../../layout/MainPageLayout";

const UploadedSheetsListPage = () => {
  const navigate = useNavigate();
  const { isLoaded } = useFetchData(ALL_UPLOADED_SHEET);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout
      headerConfig={{ title: "Uploaded Expense Sheets" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <UploadedSheetList navigate={navigate} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default UploadedSheetsListPage;
